import { render, staticRenderFns } from "./TranslationRestrictedTermsField.vue?vue&type=template&id=2f8ac79a&"
import script from "./TranslationRestrictedTermsField.vue?vue&type=script&lang=js&"
export * from "./TranslationRestrictedTermsField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports